/* eslint-disable no-console */
import { Component, DestroyRef, Inject } from '@angular/core';
import { ShellComponent } from '@core/components/shell/shell.component';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { authActions } from '@store/actions/auth.actions';
import { appSelectors } from '@store/selectors/app.selectors';
import { filter, fromEvent, map } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { appActions } from '@store/actions/app.actions';
import { EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filterNil } from 'ngxtension/filter-nil';
import { BROADCAST_CHANNEL } from '@core/core.module';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';

@Component({
  selector: 'ac-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [ShellComponent],
  host: {
    '[class.no-scroll]': '_blockedScrollSig()',
  },
})
export class AppComponent {
  protected readonly _blockedScrollSig = this._store.selectSignal(appSelectors.blockedScroll);
  protected readonly numberOfSeconds: number = 1800; // 30 minutes
  constructor(
    private _store: Store<Store>,
    private _oidcEvents: PublicEventsService,
    @Inject(BROADCAST_CHANNEL)
    private _broadcastChannel: BroadcastChannel,
    private _idle: Idle,
    private _destroyRef: DestroyRef
  ) {
    this._broadcastChannel.onmessage = () => this._store.dispatch(authActions.attemptLogout({ isMessage: true }));
    this._oidcEvents
      .registerForEvents()
      .pipe(
        filter((value) =>
          [EventTypes.CheckingAuth, EventTypes.CheckingAuthFinished, EventTypes.CheckingAuthFinishedWithError].includes(value.type)
        ),
        map((value) => value.type === EventTypes.CheckingAuth),
        takeUntilDestroyed()
      )
      .subscribe((checkingAuth) => this._store.dispatch(authActions.ongoingAuthCheck({ checking: checkingAuth })));
    if (environment.env !== 'local') {
      fromEvent(window, 'CookiebotOnLoad')
        .pipe(
          map(() => window.Cookiebot),
          filterNil(),
          takeUntilDestroyed()
        )
        .subscribe((value) => {
          if ('changed' in value && value['changed']) {
            location.reload();
          }
          if ('consent' in value) {
            this._store.dispatch(appActions.setCookiesConsent(value.consent));
          }
        });
    } else {
      this._store.dispatch(authActions.startAuth());
    }
    this._idle.setIdle(3);
    this._idle.setTimeout(this.numberOfSeconds);
    this._idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this._idle.onTimeout.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this._store.dispatch(authActions.attemptLogout({}));
    });
    this._idle.watch();
  }
}
